import { SharedApiV2 } from "@capstone/mock-api";
import { ODataReference } from "src/app/core/odata-reference.model";
import { Site } from "src/app/core/sites";
import { environment } from "src/environments";
import { getApiDetailsDecorator } from "src/utils";
import { deserializeSimpleDock, SimpleDock } from "../docks/dock-v2.model";
import { DoorGroup } from "../door-groups/door-group.model";
import { BaseDoor } from "./base-door.model";

const api = getApiDetailsDecorator<SharedApiV2.DoorSelectedListDto>();

export abstract class AbstractDoor extends BaseDoor {
  public constructor(args: ClassProperties<Door>) {
    super(args);
    this.dock = args.dock;
    this.doorGroup = args.doorGroup;
    this.id = args.id;
    this.reference = args.reference;
    this.site = args.site;
  }

  @api() public readonly id: number;
  @api() public readonly dock: SimpleDock;
  public readonly doorGroup: DoorGroup;
  // TODO: Remove after migrating the closures service.
  public readonly reference: ODataReference;
  public site: Site;

  public getRouteUrl(...childPaths: string[]): string {
    return this.dock.site.getRouteUrl(
      "settings/doors",
      String(this.id),
      ...childPaths,
    );
  }
}

interface DeserializeArgs {
  readonly site: Site;
}
export class Door extends AbstractDoor {
  public constructor(args: ClassProperties<Door>) {
    super(args);
  }

  public static deserialize(
    data: SharedApiV2.DoorSelectedListDto,
    { site }: DeserializeArgs,
  ): Door {
    return new Door({
      displaySequence: data.sortOrder,
      dock: deserializeSimpleDock(data.dock, { site }),
      doorGroup: DoorGroup.deserialize(data.doorGroup, { site }),
      id: data.id,
      maxUnitCount: data.maxUnitCount,
      minUnitCount: data.minUnitCount,
      name: data.name,
      physicalSequence: data.sequence,
      // This is a workaround since we need to use this reference in the closures.
      // TODO : Remmove this when moving closures to API V2
      reference: new ODataReference(
        `${
          environment.apiUrls.mr.href
        }partner/${site.partner.key.toString()}/Doors(${data.id})`,
      ),
      site,
    });
  }

  public static deserializeList(
    value: SharedApiV2.DoorSelectedListDto[],
    { site }: DeserializeArgs,
  ): readonly Door[] {
    return value.map((x) => Door.deserialize(x, { site }));
  }
}

export enum DoorErrorCode {
  DoorInUse = "DOOR_IN_USE",
  DoorGroupOneDock = "DoorGroupOneDock",
}
